import { NgModule } from '@angular/core';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { SharedModule } from 'lib-trend-core';
import { RcsMessageEditorComponent } from './rcs-message-editor/rcs-message-editor.component';
import { RcsMessagePreviewComponent } from './rcs-message-preview/rcs-message-preview.component';

/**
 * The RCS message editor and its preview, shared by the campaign wizard and the webhook
 * integration (SPEC-2026-10-rcs-webhook-integration-messages). A module of its own so neither
 * feature module imports the other — CampaignModule carries routes and dialog providers that do
 * not belong in IntegrationsModule (same reason as SettingsTemplateListModule).
 */
@NgModule({
  imports: [SharedModule, PickerModule],
  declarations: [RcsMessageEditorComponent, RcsMessagePreviewComponent],
  exports: [RcsMessageEditorComponent, RcsMessagePreviewComponent],
})
export class RcsMessageModule { }
